import * as yup from 'yup';
import { FIELDS } from 'screens/Panel/screens/User/screens/Edit/Edit.types';
import { UserDataForView } from 'screens/Panel/screens/User/screens/Edit/mapper/types';
import { telephoneValidation } from 'utils/form/validation';

export default yup.object().shape<UserDataForView>({
  [FIELDS.FULL_NAME]: yup.string(),
  [FIELDS.COMPANY]: yup.string(),
  [FIELDS.FCA_NUMBER]: yup.string(),
  [FIELDS.FCA_STATUS]: yup.string(),
  [FIELDS.LMC_STATUS]: yup.string(),
  [FIELDS.POSTCODE]: yup.string().required('This field is required.'),
  [FIELDS.ADDRESS_LINE_1]: yup.string(),
  [FIELDS.ADDRESS_LINE_2]: yup.string(),
  [FIELDS.HOUSE_NUMBER]: yup.string().required('This field is required.'),
  [FIELDS.CITY]: yup.string().required('This field is required.'),
  [FIELDS.COUNTY]: yup.string(),
  [FIELDS.PHONE]: telephoneValidation().required('Contact Number is required.'),
  [FIELDS.EMAIL_ADDRESS]: yup
    .string()
    .email('Please provide correct email address.')
    .required('This field is required'),
  [FIELDS.FULL_ADDRESS]: yup.string(),
});
